import { render, staticRenderFns } from "./professionals.vue?vue&type=template&id=5936948c&scoped=true&"
import script from "./professionals.vue?vue&type=script&lang=js&"
export * from "./professionals.vue?vue&type=script&lang=js&"
import style0 from "./professionals.vue?vue&type=style&index=0&id=5936948c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936948c",
  null
  
)

export default component.exports